<ng-container *ngIf="{transactionTypes: transactionTypes$ | async, product: product$ | async} as data">
  <ng-container *ngIf="slmTransactionTypes?.length > 1 && !isHeroSection && isPdpOpenCtaInfoPageEnabled; else default">
    <dcp-cta-info-page-open-button
      [slmTransactionTypes]=slmTransactionTypes
      [bundleTemplate]="bundleTemplate"
      [product]="data.product"
      class="w-100"
    >
    </dcp-cta-info-page-open-button>
  </ng-container>
  <ng-template #default>
    <div [class.flex-column]="!isHeroSection" class="d-flex flex-grow-1 w-100">
      <dcp-cta-button
        [class.udex-ms-12]="index > 0 && isHeroSection"
        *ngFor="let slmTransactionType of slmTransactionTypes; index as index"
        [slmTransactionType]="slmTransactionType"
        [transactionTypes]="data.transactionTypes"
        [bundleTemplate]="bundleTemplate"
        [product]="data.product"
        [whitelistedTransactionTypeCodes]="whitelistedTransactionTypeCodes"
        [outlineButtons]="outlineButtons"
        [highlightFirstButton]="highlightFirstButton"
        [smallButtons]="smallButtons"
        [fullWidth]="fullWidth"
        [disableMargin]="disableMargin"
        [isHeroSection]="isHeroSection"
        [buttonUiType]="buttonUiType"
      ></dcp-cta-button>
    </div>
  </ng-template>
</ng-container>
